// a jegy OLVASATLAN-jelvénye a belső listán — a jel a KÖZÖS badge-katalógusból (`ticketUnread` fogalom); a felirat
// KI VAN ÍRVA (user-döntés, 2. tesztkör: a puszta lakat + szám tooltippel nem mondta meg, mi történt)
import { useTranslation } from 'react-i18next';

import { DomainBadge } from '@/components/shared/domain-badge';

export interface TicketUnreadBadgeProps {
  /** `none` → nincs jelvény. */
  unread: 'none' | 'new_ticket' | 'external' | 'internal';
}

export function TicketUnreadBadge({ unread }: TicketUnreadBadgeProps): JSX.Element | null {
  const { t } = useTranslation();
  if (unread === 'none') return null;
  return <DomainBadge kind="ticketUnread" value={unread} label={t(`tickets.unread.${unread}`)} />;
}
